import { createBrowserRouter } from 'react-router';
import { RootLayout } from './layouts/RootLayout';
import { MainPage } from './pages/MainPage';
import { AuthPage } from './pages/AuthPage';
import { CohortPage } from './pages/CohortPage';
import { DistributePage } from './pages/DistributePage';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    children: [
      {
        index: true,
        element: <MainPage />,
      },
      {
        path: 'auth',
        element: <AuthPage />,
      },
      {
        path: ':cohortId',
        element: <CohortPage />,
      },
      {
        path: ':cohortId/distribute',
        element: <DistributePage />,
      },
    ],
  },
]);
